import { InjectionToken } from '@angular/core';
import { ApiRequestService } from '@gelato-api-ui/core/api/services/api-request.service';
import { SanityApiService } from '@gelato-api-ui/core/sanity/services/sanity-api.service';
import { KeycloakModuleConfig } from './keycloak-module-config';
import { FeatureSwitcherService } from '@gelato-api-ui/sdk/src/lib/feature-switcher/feature-switcher.service';
import { ApiModuleConfig } from './api-module-config';

export const API_MODULE_CONFIG = new InjectionToken<ApiModuleConfig>('sdk.api.module.config');
export const KEYCLOAK_MODULE_CONFIG = new InjectionToken<KeycloakModuleConfig>('sdk.keycloak.module.config');
export const API_HOST_CONFIG = new InjectionToken<ApiModuleConfig>('sdk.api.host.config');
export const FEATURE_SWITCHER_SERVICE_TOKEN = new InjectionToken<FeatureSwitcherService>('FeatureSwitcherService');
export const API_REQUEST_SERVICE_TOKEN = new InjectionToken<ApiRequestService>('ApiRequestService');
export const SANITY_API_SERVICE_TOKEN = new InjectionToken<SanityApiService>('SanityApiService');
